import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import './Header.css';

function Header() {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      setRole(null);
      if (currentUser) {
        try {
          // Special-case the main admin email so header links appear even if no users doc exists
          if (currentUser.email === 'islandlivingenterprises@gmail.com') {
            setRole('admin');
          } else {
            const userRef = doc(db, 'users', currentUser.uid);
            const snap = await getDoc(userRef);
            if (snap.exists()) {
              setRole(snap.data().role || null);
            } else {
              setRole(null);
            }
          }
        } catch (err) {
          console.error('Header: failed to read user role', err);
          setRole(null);
        }
      }
    });

    return () => unsubscribe();
  }, [auth]);

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/login');
  };

  const toggleMobile = () => setMobileOpen(v => !v);

  return (
    <header className="app-header">
      {/* Hamburger for small screens */}
      <button className="hamburger" onClick={toggleMobile} aria-label="Toggle menu">
        <span className="bar" />
        <span className="bar" />
        <span className="bar" />
      </button>

      <div className="logo">🏗️ Build Jamaica</div>
      <div className="header-nav-center">
        <Link to="/" className="nav-button">🏠 Home</Link>
        <Link to="/services" className="nav-button">🧰 Services</Link>
        <Link to="/aboutus" className="nav-button">📃 About Us</Link>
      </div>

      <nav className="nav-links">

        {/* Mobile menu (visible when hamburger toggled) */}
        <div className={`mobile-menu${mobileOpen ? ' open' : ''}`}>
          <Link to="/" className="mobile-link" onClick={()=>setMobileOpen(false)}>🏠 Home</Link>
          <Link to="/services" className="mobile-link" onClick={()=>setMobileOpen(false)}>🧰 Services</Link>
          <Link to="/aboutus" className="mobile-link" onClick={()=>setMobileOpen(false)}>📃 About Us</Link>
          {user && role === 'client' && (
            <Link to="/client-dashboard" className="mobile-link" onClick={()=>setMobileOpen(false)}>
              📋 Dash Board
            </Link>
          )}
          <Link to="/login" className="mobile-link" onClick={()=>setMobileOpen(false)}>🔐 Admin Login</Link>
          <Link to="/client-auth" className="mobile-link" onClick={()=>setMobileOpen(false)}>👤 Client Login</Link>
        </div>
        {/* Always-visible mobile CTA for clients */}
        {user && role === 'client' && (
          <Link to="/client-dashboard" className="mobile-dash" aria-label="Dashboard">
            📋 Dashboard
          </Link>
        )}
        {(!user || role !== 'client') && (
          <Link to="/client-auth" className="mobile-login" aria-label="Login">
            🔑 Login
          </Link>
        )}
        {user && role === 'admin' ? (
          <>
            <Link to="/dashboard" className="nav-button">📋 Dashboard</Link>
            <button onClick={handleLogout} className="nav-button logout">🚪 Logout</button>
          </>
        ) : user && role === 'contractor' ? (
          <>
            <Link to={`/dashboard/${user.uid}`} className="nav-button">📋 Contractor Dashboard</Link>
            <button onClick={handleLogout} className="nav-button logout">🚪 Logout</button>
          </>
        ) : user && role === 'client' ? (
          <>
            <Link to="/client-dashboard" className="nav-button">📋 Dashboard</Link>
            <button onClick={handleLogout} className="nav-button logout">🚪 Logout</button>
          </>
        ) : (
          <>
            <div className="auth-links">
              <div className="auth-stack auth-stack-wide">
                <Link to="/login" className="nav-button auth-btn">
                  🔐 Admin Login
                </Link>
              </div>
              <div className="auth-stack auth-stack-wide">
                <Link to="/client-auth" className="nav-button auth-btn">
                  👤 Client Login
                </Link>
                <Link to="/client-auth?register=1" className="nav-link auth-sub">
                  Create Client Account
                </Link>
              </div>
            </div>
          </>
        )}
      </nav>
    </header>
  );
}

export default Header;